import { FireRiskEnum } from '../enum/FireRisk.enum'

export class FireRiskColorFactory {
	static make(risk: FireRiskEnum): string {
		switch (risk) {
			case FireRiskEnum.NONE:
				return '#808080'
			case FireRiskEnum.NULL:
				return '#009E27'
			case FireRiskEnum.SMALL:
				return '#A2D800'
			case FireRiskEnum.MEDIUM:
				return '#FFD700'
			case FireRiskEnum.HIGH:
				return '#FF7C36'
			case FireRiskEnum.HIGHEST:
				return '#CE1619'
			default:
				return '#000000'
		}
	}
}
